<template>
  <v-list two-line>
    <template v-for="(item, index) in items">
      <v-list-item :key="item.id" @click="$emit('rowClicked', item)">
        <v-list-item-content>
          <v-list-item-title v-text="item.title" />

          <v-list-item-subtitle class="text--primary" v-text="item.subtitle" />

          <v-list-item-subtitle v-text="item.text" />
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text v-text="item.counts" />
          <ORow>
            <v-icon class="amber" small v-if="item.isPaused"
              >mdi-alpha-p</v-icon
            >
            <v-icon class="red" small v-if="item.isIgnored">mdi-alpha-i</v-icon>
          </ORow>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="index < items.length - 1" :key="index" />
    </template>
  </v-list>
</template>

<script>
import _ from 'lodash'
import { atMost } from 'oderon-commons/src/utils'

export default {
  props: {
    rows: { type: Array }
  },
  computed: {
    items() {
      return this.rows.map((row) => {
        let text = _.get(row, 'worker.state') || 'missing'
        let errMessage = _.get(row, 'worker.lastWorkerErrorMessage')

        if (text == 'stopped' || text == 'errored') {
          errMessage = atMost(errMessage || '(no error msg)', 100)
          text += ' ─ ' + errMessage
        }

        let qname = row.name || _.get(row, 'queue.name')
        let active = row.active || _.get(row, 'queue.active')
        let waiting = row.waiting || _.get(row, 'queue.waiting')

        return {
          id: qname,
          isPaused: row.isPaused,
          isIgnored: row.isIgnored,
          title: qname,
          subtitle: row.vehicleCode,
          text,
          counts: `${active || 0}─${waiting || 0}`
        }
      })
    }
  }
}
</script>

<style></style>
